// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__146uI","inner":"Footer_inner__1QPpd"};